import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { SCRUM } from '@atlassian/jira-common-directory-v2/src/model/constants.tsx';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import getActiveSprints from '../../services/get-active-sprints/index.tsx';
import {
	type Action,
	GET_ACTIVE_SPRINTS,
	activeSprintsRetrieved,
	getActiveSprintsFailed,
} from '../../state/actions.tsx';
import { getBoard, getOnInitialised } from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';

const getActiveSprintsEpic = (action$: ActionsObservable<Action>, store: MiddlewareAPI<State>) =>
	action$.ofType(GET_ACTIVE_SPRINTS).mergeMap(() => {
		const state = store.getState();
		const board = getBoard(state);

		// @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'. | TS2339 - Property 'type' does not exist on type 'Board'.
		const shouldSkipCheckingActiveSprints = board.isPrivate || board.type !== SCRUM;
		if (shouldSkipCheckingActiveSprints) {
			getOnInitialised(state)();
			return Observable.of(activeSprintsRetrieved([]));
		}

		return (
			Observable.fromPromise(getActiveSprints(board.id))
				.mergeMap((sprints) => {
					getOnInitialised(state)();
					return Observable.of(activeSprintsRetrieved(sprints));
				})
				// @ts-expect-error - TS2345 - Argument of type '(error: FetchError) => Observable<ActiveSprintsRetrievedAction> | Observable<GetActiveSprintsFailedAction>' is not assignable to parameter of type '(err: any, caught: Observable<ActiveSprintsRetrievedAction>) => ObservableInput<ActiveSprintsRetrievedAction>'.
				.catch((error: FetchError) => {
					if (error.statusCode === 404) {
						return Observable.of(activeSprintsRetrieved([]));
					}
					log.safeErrorWithoutCustomerData(
						'directories.boards-v2.delete-modal.ops.get-active-sprints',
						error.message,
						error,
					);
					return Observable.of(getActiveSprintsFailed());
				})
		);
	});

export default getActiveSprintsEpic;
